import template from './bank-account-type-selector.html';

export default angular
  .module('app.holding.dashboard.bank-accounts')
  .directive('holdingBankAccountTypeSelector', holdingBankAccountTypeSelector)
  .name;

function holdingBankAccountTypeSelector() {
  'ngInject';

  return {
    link,
    replace: true,
    require: 'ngModel',
    restrict: 'E',
    scope: {
      enabledTypes: '=',
    },
    template,
  };

  function link(scope, _elem, _attrs, model) {
    function select(type) {
      scope.type = type;
      if (scope.enabledTypes.includes(type)) {
        model.$setViewValue(type);
      }
    }

    scope.$watch('enabledTypes', (types) => {
      scope.brokerageDisabled = !types.includes('Brokerage');
      scope.personalDisabled = !types.includes('Personal');
      if (types.length === 1) {
        scope.type = types[0];
        model.$setViewValue(types[0]);
      }
      scope.selectorTypes = types.map(type => ({
        value: type,
        label: type,
      }));
    });

    scope.$watch('type', select);
    model.$formatters.push((type) => {
      scope.type = type;
    });

    scope.model = model;
    scope.select = select;
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/bank-accounts/directives/bank-account-type-selector/bank-account-type-selector.js